export const getEnv = () => process.env["NEXT_PUBLIC_VERCEL_ENV"];

export const isProduction = () => getEnv() === "production";
export const isDevelopment = () => getEnv() === "development";
export const isPreview = () => getEnv() === "preview";

export const getVersion = () => process.env["NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA"] ?? "unknown";

export const getBaseUrl = () => {
  // In production, we expose our app by proxying from the stedi.com domain.
  if (isProduction()) {
    return "https://www.stedi.com";
  }

  if (process.env["NEXT_PUBLIC_VERCEL_URL"]) {
    return `https://${process.env["NEXT_PUBLIC_VERCEL_URL"]}`;
  }

  return "http://localhost:3000";
};
